const types = {
  CLEAR_CURRENT: 'BUSINESSES_CLEAR_CURRENT',
  GET_REQUEST: 'BUSINESSES_GET_REQUEST',
  GET_SUCCESS: 'BUSINESSES_GET_SUCCESS',
  GET_FAILURE: 'BUSINESSES_GET_FAILURE',

  SAVE_REQUEST: 'BUSINESSES_SAVE_REQUEST',
  SAVE_SUCCESS: 'BUSINESSES_SAVE_SUCCESS',
  SAVE_FAILURE: 'BUSINESSES_SAVE_FAILURE',

  GETALL_REQUEST: 'BUSINESSES_GETALL_REQUEST',
  GETALL_SUCCESS: 'BUSINESSES_GETALL_SUCCESS',
  GETALL_FAILURE: 'BUSINESSES_GETALL_FAILURE',

  DELETE_REQUEST: 'BUSINESSES_DELETE_REQUEST',
  DELETE_SUCCESS: 'BUSINESSES_DELETE_SUCCESS',
  DELETE_FAILURE: 'BUSINESSES_DELETE_FAILURE',    

  UPDATE_REQUEST: 'BUSINESSES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'BUSINESSES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'BUSINESSES_UPDATE_FAILURE'    

};

export default types;